import Box from '@mui/material/Box'
import Chip from '@mui/material/Chip'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import SvgIcon from '@mui/material/SvgIcon'
import { useTheme } from '@mui/material/styles'
import { Building03, LayersThree01 } from '@untitled-ui/icons-react'
import { Group } from '@/api'
import useTranslate from '@/hooks/use-translate'
import { agencyIconSx } from '@/sections/settings/agency-group-utils'
import { isWizardOrganizationRoot } from '../utils/wizardGroupConfigurations'

const COMPACT_ICON_BOX_PX = 24
const COMPACT_ICON_PX = 14
const MENU_ICON_BOX_PX = 28
const MENU_ICON_PX = 16

export type WizardAgencyOptionLabelProps = {
  group: Group
  /** Select fermé : icône plus petite pour tenir dans le champ 36px. */
  compact?: boolean
  /** Badge « Organisation » dans la liste déroulante. */
  showOrganizationBadge?: boolean
}

export function WizardAgencyOptionLabel({
  group,
  compact = false,
  showOrganizationBadge = false,
}: WizardAgencyOptionLabelProps) {
  const theme = useTheme()
  const { t: tUpload } = useTranslate('upload')
  const isOrg = isWizardOrganizationRoot(group)
  const variant = isOrg ? 'primary' : 'nested'
  const boxPx = compact ? COMPACT_ICON_BOX_PX : MENU_ICON_BOX_PX
  const iconPx = compact ? COMPACT_ICON_PX : MENU_ICON_PX

  return (
    <Stack direction="row" alignItems="center" spacing={1} sx={{ minWidth: 0 }}>
      <Box
        sx={{
          ...agencyIconSx(theme, variant),
          width: boxPx,
          height: boxPx,
          borderRadius: compact ? '6px' : '8px',
        }}
      >
        <SvgIcon sx={{ fontSize: iconPx, display: 'block' }}>
          {isOrg ? (
            <Building03 style={{ display: 'block' }} />
          ) : (
            <LayersThree01 style={{ display: 'block' }} />
          )}
        </SvgIcon>
      </Box>
      <Typography
        component="span"
        noWrap
        sx={{
          fontSize: 11.5,
          lineHeight: 1.2,
          minWidth: 0,
          flex: 1,
        }}
      >
        {group.name}
      </Typography>
      {showOrganizationBadge && isOrg ? (
        <Chip
          label={tUpload('wizardAgencyOrganizationBadge')}
          size="small"
          sx={{
            height: 20,
            flexShrink: 0,
            fontWeight: 600,
            '& .MuiChip-label': { px: 0.75, fontSize: 9, lineHeight: 1.2 },
          }}
        />
      ) : null}
    </Stack>
  )
}

export default WizardAgencyOptionLabel
